<template>
  <main>
    <section-hero :bgImg="bgImg"></section-hero>
    <section class="section--search" id="scrollToOnLoad">
      <b-container>
        <div class="search">
          <input type="text" placeholder="Search" class="search__input" @keyup.enter="search"
            v-model="searchQuery">
          <button class="search__ico" @click="search">
            <i class="fas fa-search fa-lg"></i>
          </button>
        </div>
        <div>
          <h2>Articles: </h2>
          <results-list :resultsList="articles" type="articles"></results-list>
        </div>
        <div>
          <h2>News: </h2>
          <results-list :resultsList="news" type="news"></results-list>
        </div>
      </b-container>
    </section>
  </main>
</template>
<script>
import search from '@/api/v1/search';
import Hero from '@/components/Hero';
import ResultsList from '@/views/Search/ResultsList';

export default {
  components: {
    'section-hero': Hero,
    ResultsList,
  },
  data() {
    return {
      bgImg: 'Banner7-Home-',
      searchQuery: '',
      articles: [],
      news: [],
    };
  },
  methods: {
    search() {
      const succ = (response) => {
        this.articles = response.data.articles;
        this.news = response.data.news;
      };
      search.search(succ, this.searchQuery);
      this.$router.push({ name: 'search', query: { search: this.searchQuery } });
    },
  },
  created() {
    this.searchQuery = this.$route.query.search;
    this.search();
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.section {
  &--search {
    padding: 100px;
  }
}
.search {
  position: relative;
  margin-bottom: 100px;
  &__input {
    border: 2px solid $color--gray;
    border-radius: 35px;
    width: 100%;
    height: 50px;
    background-color: transparent;
    outline: none;
    padding: 10px 20px;
    font-size: 16px;
  }
  &__ico {
    margin: 0;
    padding: 0;
    position: absolute;
    color: $color--gray;
    top: 14px;
    right: 20px;
  }
}
.results {
  width: 100%;
  margin: 50px 0;
  &__img {
    min-height: 300px;
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/Search.vue